export default "__VITE_ASSET__D9wEm27z__"